import { useSelector } from 'react-redux'

import { getYaPayFeatureConfig } from '@/app/model/selectors/getYaPayFeatureConfig/getYaPayFeatureConfig'
import { dolyameSelector } from '@/app/model/selectors/selectors'

import { useCheckAuth } from '@/features/auth/check'

import { isAuthorizationInited } from '@/entities/user'

import { OrderType, ProductControl } from '@/shared/types/product-types'

import { useProductPaymentsQuery } from './use-product-payments-query'
import { useProduct } from './useProduct'

export const useProductFlags = () => {
	const { product } = useProduct()
	const { data } = useProductPaymentsQuery(Number(product.ID))

	const availablePayments = data?.data?.PAYMENTS

	const isAuthInited = useSelector(isAuthorizationInited)
	const { isAuthorized } = useCheckAuth()

	const { ACTIVE, SPLIT_MAX_LIMIT } = useSelector(getYaPayFeatureConfig)

	const isArchive = product.ORDER_TYPE === OrderType.Archive || product.ORDER_TYPE === OrderType.HideBuy

	const isInStock = product?.CONTROL?.length
		? !product?.CONTROL.includes(ProductControl.HideBuy) && !product?.CONTROL.includes(ProductControl.HidePrice)
		: true

	const isProductBuy =
		product.ORDER_TYPE === OrderType.Order ||
		product.ORDER_TYPE === OrderType.PreOrder ||
		product.ORDER_TYPE === OrderType.Prereservation ||
		product.ORDER_TYPE === OrderType.Reservation ||
		product.ORDER_TYPE === OrderType.TCP

	const productIsInStock =
		product.ORDER_TYPE !== OrderType.Prereservation &&
		product.ORDER_TYPE !== OrderType.Archive &&
		product.ORDER_TYPE !== OrderType.HideBuy &&
		product.ORDER_TYPE !== OrderType.Reservation

	const showAuthTrigger = isAuthInited && !isAuthorized && productIsInStock && isInStock

	const isIphone = product.TITLE.includes(`Apple iPhone`)

	const isPriceUnderLimit = product?.PRICE?.VALUE <= Number(SPLIT_MAX_LIMIT)
	const isShowYandexSplitWidget = ACTIVE && isProductBuy && isPriceUnderLimit

	const showCreditPanel =
		!!availablePayments?.INSTALLMENT?.length ||
		!!availablePayments?.CREDIT?.length ||
		!!availablePayments?.LIMIT?.length

	const isSplitPaymentAvailable = !!availablePayments?.PARTS?.find(item => item.CODE === 'SPLIT')
	const showSplit = isSplitPaymentAvailable && OrderType.Prereservation !== product.ORDER_TYPE

	const { ACTIVE: dolyameActive, MIN_PRICE_LIMIT: dolyameLimit } = useSelector(dolyameSelector)

	const isPriceOk = Number(product?.PRICE?.VALUE) > Number(dolyameLimit || 0)
	const typeOrderOk = product?.ORDER_TYPE === OrderType.Order
	const SHOW_DOLYAME = isPriceOk && dolyameActive && typeOrderOk

	// @ts-ignore
	const isShowDiscount = product.HAS_DISCOUNT
	// @ts-ignore
	const isShowMarkdown = product.HAS_MARKDOWN

	return {
		isArchive,
		isProductBuy,
		isIphone,
		isShowYandexSplitWidget,
		isSplitPaymentAvailable,
		isPriceUnderLimit,
		isShowDiscount,
		isShowMarkdown,
		productIsInStock,
		showAuthTrigger,
		showCreditPanel,
		showSplit,
		SHOW_DOLYAME,
		isInStock
	}
}
